<template>
  <v-container>
    <v-layout
      text-xs-center
      wrap
    >
    <v-spacer></v-spacer>
    <v-text-field
        v-model="search"
        append-icon="search"
        label="Suche"
        single-line
        hide-details
      ></v-text-field>
    <v-flex xs12>
      <v-data-table
        :rows-per-page-items="[25, 50, 75]"
        :headers="headers"
        :items="users"
        :search="search"
        class="elevation-1"
      >
        <template v-slot:items="props">
          <td class="text-xs-left">{{ props.item.email }}</td>
          <td class="deletebutton"><DeleteButton :id="props.item.id" backendRoute="deleteuser" @itemDeleted="collectResults"/></td>
        </template>
        <template v-slot:no-results>
          <v-alert :value="true" color="error" icon="warning">
            Ihre Suche nach "{{ search }}" Es wurden keine Ergebnisse gefunden.
          </v-alert>
        </template>
      </v-data-table>
    </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'
import _ from 'lodash'
  export default {
    data () {
      return {
        search: '',
        headers: [
          { text: 'Email', value: 'email', sortable: true},
          { text: ''}
        ],
        users: [],
      }
    },
    created() {
      this.collectResults()
    },
    methods: {
      changeLocale () {
        this.$vuetify.lang.current = 'sv'
      },
      collectResults(){
        axios.get('users.php')
        .then(response => {
          let users = response.data
          this.users = users.data
        })
      }
    },
    components: {
      'DeleteButton': () => import('../components/DeleteButton.vue')
    }
  }
</script>

<style lang="css">
.v-input__slot {
  margin-bottom: 20px !important;
}
.v-datatable__actions__select{
  visibility: hidden !important;
}
.v-table__overflow{
  margin-top: 5px;
}
.printbutton, .deletebutton {
padding:0!important;
}
.deletebutton .v-btn {
    min-width: 0;
    padding: 0px!important;
    margin-left:0px;
    margin-right:10px;
}

.deletebutton .v-btn:hover:before, .deletebutton .v-btn:focus:before {
    background-color: transparent;
}
.v-datatable .sortable .v-icon {
  display:none!important;
}
</style>
